import React from 'react';
import './BlogContent.css';
import { Link } from 'react-router-dom';

const blogData = [
    {
        id: 1,
        title: "When to Use Vertical Blinds Instead of Horizontal Blinds",
        description: "The sheer variety of window treatments makes the choice of the right fit for your windows a bit challenging. The extensive range available in the market today features a wide collection of materials, colour schemes, patterns, and textures[...]",
        image: "/Assets/BlogImages/01.webp",
        date: "18 November 2020",
        link: "/blog/when-to-use-vertical-blinds-instead-of-horizontal-blinds/",
    },
    {
        id: 2,
        title: "Colours of Happiness within Blinds",
        description: "Colours bring upon an undefeatable joy in our black & white lives where we try to find happiness all the time. What one really needs to understand is happiness[...]",
        image: "/Assets/BlogImages/02.webp",
        date: "18 November 2020",
        link: "/blog/colours-of-happiness-within-blinds/",
    },
    {
        id: 3,
        title: "Blinds for Different Rooms",
        description: "We chose the matching decorative material such as chairs, bed sheets etc. that add more of a glow to the rooms. Similar is the case for window blinds[...]",
        image: "/Assets/BlogImages/blog1.webp",
        date: "4 November 2020",
        link: "/blog/blinds-for-different-rooms/",
    },
    {
        id: 4,
        title: "5 Reasons to choose Callistus Roller Blinds",
        description: "If you’re thinking about choosing a Roller blind for your home, you’ll want to read this. Here are 5 reasons to choose the stylish yet practical blind type.[...]",
        image: "/Assets/BlogImages/blog2.webp",
        date: "4 November 2020",
        link: "/blog/5-reasons-to-choose-callistus-roller-blinds/",
    },
    {
        id: 5,
        title: "Save Energy with Most Energy Efficient Blinds – Colby Blinds",
        description: "Utmost Energy Efficient Blinds specifically engineered to provide beauty and energy efficiency in both cold and warm climates. Callistus Colby Blind combines soft, seamless fabrics with crisp even pleats that hold their shape indefinitely.[...]",
        image: "/Assets/BlogImages/Colby-1.webp",
        date: "25 September 2020",
        link: "/blog/new-your-home-with-interior-shutters/",
    },
    {
        id: 6,
        title: "Balancing Light",
        description: "Light plays an important role in setting the atmosphere right in our rooms. Too much off glaring sun can make the room hot and uncomfortable and similarly too[...]",
        image: "/Assets/BlogImages/smst.webp",
        date: "25 September 2020",
        link: "/blog/test-does-it-come-from-where/",
    },
    {
        id: 7,
        title: "Tips to Select the Correct Blinds for your Home",
        description: "It can become very confusing while selecting the perfect blinds when you have huge collection to make the selection from; fear not our tips might [...]",
        image: "/Assets/BlogImages/wooden-1.webp",
        date: "18 August 2020",
        link: "/blog/where-does-it-come-from-where/",
    },
    {
        id: 8,
        title: "Looking for Options? Look no further",
        description: "While choosing anything in life we always wish that we have options available; and we at Callistus have various options not only in Blinds and operating systems but also various patterns and colors in fabrics for each blind[...]",
        image: "/Assets/BlogImages/roman.webp",
        date: "6 May 2020",
        link: "/blog/transform-your-home-with-interior-shutters/",
    },
    {
        id: 9,
        title: "Curtains with Blinds",
        description: "Often one wonders whether it is ok to pair window blinds with curtains? Would they look good? Would it be over the top? Will it enhance the interior or make it look gaudy? Should I go with plain or printed or mix them? Fear not[...]",
        image: "/Assets/BlogImages/curtain.webp",
        date: "3 October 2020",
        link: "/blog/curtains-with-blinds/",
    },
    {
        id: 10,
        title: "Special features for Blackout Blinds",
        description: "While buying anything the basic thing we need to know is to about its pros and cons and also any special benefits the product has; similarly, while choosing[...]",
        image: "/Assets/BlogImages/roller-2.webp",
        date: "3 October 2020",
        link: "/blog/special-features-for-blackout-blinds/",
    },
];

const BlogContent = () => {
    return (
        <div className="Blog-pg-container">
            <div className="blog-page">
                <div className="blog-header">
                    <h1>Blog</h1>
                    <p>
                        Welcome to our blog, full of our ideas and passions. We care about creating beautiful window coverings as you care about creating an elegant home.
                    </p>
                </div>

                {Array.from({ length: 5 }, (_, rowIndex) => {
                    const left = blogData[rowIndex * 2];
                    const right = blogData[rowIndex * 2 + 1];
                    const isEven = rowIndex % 2 === 0;

                    return (
                        <div key={rowIndex} className="blog-row">
                            <div className={`blog-card ${isEven ? 'wide' : 'narrow'} card-left`}>
                                <img src={left.image} alt={left.title} />
                                {isEven && (
                                    <div className="card-content-wrapper">
                                        <h2>{left.title}</h2>
                                        <p>{left.description}</p>
                                        <Link to={left.link} className="read-more-btn">Read More</Link>
                                        <span className="date">{left.date}</span>
                                    </div>
                                )}
                                {!isEven && (
                                    <>
                                        <h2>{left.title}</h2>
                                        <p>{left.description}</p>
                                        <Link to={left.link} className="read-more-btn">Read More</Link>
                                        <span className="date">{left.date}</span>
                                    </>
                                )}
                            </div>

                            <div className={`blog-card ${isEven ? 'narrow' : 'wide'} card-right`}>

                                <img src={right.image} alt={right.title} />
                                {!isEven && (
                                    <div className="card-content-wrapper">
                                        <h2>{right.title}</h2>
                                        <p>{right.description}</p>
                                        <Link to={right.link} className="read-more-btn">Read More</Link>
                                        <span className="date">{right.date}</span>
                                    </div>
                                )}
                                {isEven && (
                                    <>
                                        <h2>{right.title}</h2>
                                        <p>{right.description}</p>
                                        <Link to={right.link} className="read-more-btn">Read More</Link>
                                        <span className="date">{right.date}</span>
                                    </>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default BlogContent;
